import React, { Component } from "react";
import Select from "react-select";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import Cx from "classnames";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import InputText from '../../../../common/components/input-text/input-text';
import { material_type, vehicle_type } from "Utils/common";
import { debounce } from "Utils/index";


class AddRawMaterialMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        product_master_id: this.props.editData ? this.props.editData["product_master_id"] : "",
        product_name: this.props.editData ? this.props.editData["product_name"] : "",
        vehicle_type: this.props.editData ? this.props.editData.vehicle_type : "",
        material_type: this.props.editData ? this.props.editData.material_type : "",
        route_code: this.props.editData ? this.props.editData.route_code : "",
        route: this.props.editData ? this.props.editData.route : "",
        product: this.props.editData
          ? this.props.editData["product"]
          : "",
        company_id: this.props.editData
          ? this.props.editData.company_id
          : this.props.companyId,
      },
    };
    this.debouncedGetInventoryItemData = debounce(this.props.getInventoryItem, 300);
  }

  

  componentDidMount() {
    setItemToSessionStorage("previousrawMaterialName", this.props.editData);
  }

  onChangeHandler = (value, id) => {
    let { data } = this.state;
    data[id] = value;
    this.setState({ data });
  };

  handleChange = (id, selcetedOption) => {
    let { data } = this.state;
    if (["vehicle_type"].includes(id)) {
      data[id] = selcetedOption.value;
      data["vehicle_type"] = selcetedOption.label;
    } else if (["material_type"].includes(id)) {
      data[id] = selcetedOption.value;
      data["material_type"] = selcetedOption.label;
    } else {
      data[id] = selcetedOption.value;
    }
    this.setState({ data });
  };

  	onChangeProductDetails = (e, id) => {
		let { data } = this.state;
		data.product = e.value;
		data.product_name = e.label;
		data.product_master_id = e.productId;
		this.setState({ data });
	}
  	onChangeRouteDetails = (e, id) => {
		let { data } = this.state;
		data.route_code = e.value;
    data.route = e.route;
		this.setState({ data });
	}

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate(data);
  };

  render() {
    const { data } = this.state;
    let optionProduct = [];
    let optionRoute = [];
    if(this.props.productList){
			for(let i = 0; i < this.props.productList.length-1; i++) {
				optionProduct.push({
					value: this.props.productList[i].product,
					label: this.props.productList[i].materialName,
					productId: this.props.productList[i].productMasterId
				});
			} 
		}
    if(this.props.routeCodeList){
			for(let i = 0; i < this.props.routeCodeList.length-1; i++) {
				optionRoute.push({
					value: this.props.routeCodeList[i].sap_code,
					label: this.props.routeCodeList[i].sap_code,
          route: `${this.props.routeCodeList[i].source}-${this.props.routeCodeList[i].destination}`, 
				});
			} 
		}

    const disable = !(
      data["vehicle_type"] &&
      data["route_code"] &&
      data["material_type"] &&
      data["product"]
    );

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup" style={{minHeight:"600px"}}>
          <div className="pop-heading">
            {`${this.props.editData ? "Edit" : "Add"} Raw Material Master`}
          </div>
          <div className="route-detail">
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px" }}
            >
               <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">
                  {"Material Name"}
                  <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={optionProduct}
                  value={optionProduct.find(prod => prod.value == data.product)}
                  onChange={(e) => this.onChangeProductDetails(e, 'product')}
                  isSearchable={true}
								  isClearable={true}
                  onInputChange={(value) => {
                  if (value.length > 3) {
                      this.debouncedGetInventoryItemData(value);
                  }
										return value
                  }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">
                  {"Material Type"}
                  <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={material_type}
                  value={material_type.find((val) => val.label == data["material_type"])}
                  onChange={this.handleChange.bind(this, "material_type")}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">
                  {"Vehicle Type"}
                  <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={vehicle_type}
                  value={vehicle_type.find((val) => val.label == data["vehicle_type"])}
                  onChange={this.handleChange.bind(this, "vehicle_type")}
                />
              </div>
              
            </div>

            <div
              className="details-section"
              style={{ display: "flex", gap: "30px", marginTop: "20px" }}
            >
             
              
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">
                  {"Route Code"}
                  <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={optionRoute}
                  value={optionRoute.find(prod => prod.value === data["route_code"])}
                  onChange={(e) => this.onChangeRouteDetails(e, 'route_code')}
                />
              </div>
              <div>
              <InputText
                placeholder=""
                id={"route"}
                label="Route"
                changeHandler={(value) => this.onChangeHandler(value, "route")}
                value={data["route"]}
                required={true}
              />
               </div>
            </div>

            <div className={"button_route"} style={{ marginTop: "50px" }}>
              <Button value={"Cancel"} click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button 
                value={"Save"} 
                click={this.onSave}  
                disabled={disable}
                />
              ) : (
                <Button
                  value={"Update"}
                  click={this.onUpdate}
                  disabled={disable}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddRawMaterialMaster;
